'use client'

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

interface ConditionalRenderProps {
    excludePaths: string[];
    children: React.ReactNode;
}

const ConditionalRender: React.FC<ConditionalRenderProps> = ({ excludePaths, children }) => {
    const [shouldRender, setShouldRender] = useState(true);
    const pathname = usePathname()

    useEffect(() => {
        // Check if the current pathname includes any path from the excludePaths array
        const shouldExclude = excludePaths.some((path) => pathname.includes(path));
        setShouldRender(!shouldExclude);
    }, [pathname, excludePaths]);

    return shouldRender ? <>{children}</> : null;
};

export default ConditionalRender;
